<template>
  <div class="hunts">
    <Table
      :headerConfigs="tableHeaderConfigs"
      :tableData="hunts"
      initialSortProperty="startsAt"
      :initialSortAscending="false"
      v-if="hasHunts"
    >
      <template v-slot:tableRow="{ rowObject }">
        <td>
          <span>{{ rowObject.status }}</span>
        </td>
        <td>
          <span>{{ rowObject.name }}</span>
        </td>
        <td>
          <a @click="huntSelected(rowObject)">{{ rowObject.id }}_LLGroup</a>
        </td>
        <td>
          <span v-if="rowObject.createdBy">
            <span v-if="nameOfUserWithId(rowObject.createdBy)"
              >{{ nameOfUserWithId(rowObject.createdBy) }} (<span
                >{{ rowObject.createdBy }}_LLUser</span
              >)</span
            >
            <span v-else>{{ rowObject.createdBy }}_LLUser</span>
          </span>
        </td>
        <td>
          <span>{{ rowObject.startsAt }}</span>
        </td>
        <td>
          <span>{{ rowObject.endsAt }}</span>
        </td>
      </template>
    </Table>
  </div>
</template>

<script>
import Table from "@/components/utils/Table";

import {
  LOAD_USERS_WITH_IDS,
  GET_USER_WITH_ID
} from "@/modules/users/usersCacheStore.js";

export default {
  name: "HuntsList",

  components: { Table },

  props: {
    hunts: {
      type: Array,
      default: () => []
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      tableHeaderConfigs: [
        {
          property: "status",
          title: "Status",
          sortable: true
        },
        {
          property: "name",
          title: "Name",
          sortable: true
        },
        {
          property: "id",
          title: "Id",
          sortable: true
        },
        {
          property: "createdBy",
          title: "Created By",
          sortable: true
        },
        {
          property: "startsAt",
          title: "Starts At",
          sortable: true
        },
        {
          property: "endsAt",
          title: "Ends At",
          sortable: true
        }
      ]
    };
  },

  mounted() {
    const loadUserWithIdsAction = `${this.usersCacheStorePath}/${LOAD_USERS_WITH_IDS}`;
    const userIds = this.hunts.map(hunt => hunt.createdBy);
    this.$store.dispatch(loadUserWithIdsAction, { userIds });
  },

  methods: {
    huntSelected(hunt) {
      this.$emit("hunt-selected", hunt);
    },

    nameOfUserWithId(userId) {
      if (!userId) {
        return null;
      }

      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`;
      const user = this.$store.getters[getUserWithIdPath](userId);

      if (!user) {
        return null;
      }

      return `${user.firstName} ${user.lastName}`;
    }
  },

  computed: {
    hasHunts() {
      if (!this.hunts) {
        return false;
      }

      return this.hunts.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  width: 100%;
}
</style>
